import React from 'react';
import PropTypes from 'prop-types';
import { useFormContext, Controller } from 'react-hook-form';
import { TextField } from '@mui/material';

export const SelectField = ({
  name,
  label,
  defaultValue,
  size,
  children,
  disabled,
  required,
  error,
  helperText,
  readOnly,
}) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      select
      defaultValue={defaultValue}
      render={({ field }) => (
        <TextField
          {...field}
          select
          sx={{ width: '100%' }}
          size={size}
          label={label}
          required={required}
          disabled={disabled}
          error={error}
          helperText={helperText}
          inputProps={{ readOnly }}
        >
          {children}
        </TextField>
      )}
    />
  );
};

SelectField.defaultProps = {
  defaultValue: '',
  label: '',
  size: 'small',
  disabled: false,
  required: false,
  error: false,
  helperText: '',
  readOnly: false,
};

SelectField.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  defaultValue: PropTypes.any,
  size: PropTypes.string,
  children: PropTypes.node.isRequired,
  disabled: PropTypes.bool,
  required: PropTypes.bool,
  error: PropTypes.bool,
  helperText: PropTypes.string,
  readOnly: PropTypes.bool,
};
